export const FORMS = {
    EXTERNALREQUEST: 'EXTERNALREQUEST',
    ASSISTENT: 'ASSISTENT',
}